import React from "react";
import classNames from "classnames";
import {isChristmas} from "../../utils/other";

const ROUND_PRECISION = 1000;

function getPercentage(now, min, max) {
    let percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

export default class ProgressBar extends React.Component {
    render() {
        const isItChristmas = isChristmas(true);
        const percent = Math.min(getPercentage(this.props.now, this.props.min, this.props.max), 100);
        return (
            <div className={classNames("progress", {"christmas": isItChristmas})}>
                <div className={classNames("progress-bar", {
                    "progress-bar-striped": !!this.props.striped || isItChristmas,
                    "progress-bar-animated": !!this.props.animated || isItChristmas,
                })}
                     style={{width: percent + "%", ...(this.props.style || {})}}>
                    {this.props.children}
                    {percent > 0 && <span className={classNames({"sr-only": this.props.srOnly})}>{this.props.label}</span>}
                    {percent > 0 && isItChristmas ? <div className="santa">
                        <div className="body">
                            <div className="head">
                                <div className="ear"/>
                                <div className="ear"/>
                                <div className="hat"/>
                                <div className="eye"/>
                                <div className="eye"/>
                                <div className="nose"/>
                                <div className="mouth"/>
                            </div>
                        </div>
                    </div> : null}
                </div>
            </div>
        );
    }
}